import React, { useCallback, useContext } from 'react';

import { FirmUsersContext } from '../../firm-users.context';
import FirmUsersForm from '../form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(FirmUsersContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <FirmUsersForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
